import { useState } from 'react'
import Icon from '@web-ui-kit/icon'
import { TopNavigation } from '@web-ui-kit/top-navigation'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import useMediaQuery from '@web-ui-kit/hooks.use-media-query'
import Avatar from '@web-ui-kit/avatar'
import * as Sc from './Header.style'
import NotificationsSystem from './_components/NotificationsSystem'
import { ICONS } from './utils/constants'
import useNotifications from './hooks/useNotifications'
import ProfileMenu from './_components/ProfileMenu'
import MladinskaLogo from './assets/MladinskaLogo'
import NavigationItems from 'components/TopNavigation'
import { NAVIGATION_TYPES } from 'utils/constants'
import { EXTERNAL_LINKS } from 'utils/constants/route'
import Navigation from 'components/Navigation'
import { useGetUser } from 'hooks/user'
import { isMladinskaPublisher } from 'utils'
import useCheckCanary from 'hooks/useCheckCanary'

const Header = ({ children, className }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const { counter: notificationsCounter } = useNotifications()
  const { isLarge, isExtraSmall } = useMediaQuery()
  const showNewAlertCenter = useCheckCanary(
    window?.rebranding?.canaryUsers,
    window?.rebranding?.enableAlerteCenter
  )
  const {
    i18n: { language },
  } = useTranslation()
  const {
    data: { color, initials, publishers },
  } = useGetUser()

  if (children)
    return <Sc.Container className={className}>{children}</Sc.Container>

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false)
  }

  const topbarHelp = {
    icon: {
      element: ICONS.HELP,
      onClick: () => {
        const url =
          (window?.zendesk?.urls && window?.zendesk?.urls[language]) ??
          EXTERNAL_LINKS.HELP_ZENDESK
        window.open(url, '_blank')
      },
    },
    id: ICONS.HELP,
  }
  const notification = {
    icon: {
      badgeNumber: notificationsCounter,
      disabled: !notificationsCounter,
      element: ICONS.NOTIFICATION,
    },
    id: ICONS.NOTIFICATION,
    menu: notificationsCounter ? <NotificationsSystem /> : null,
  }
  const topbarProfile = {
    icon: {
      element: <Avatar color={color} size='small' text={initials} />,
    },
    id: ICONS.PROFILE,
    menu: <ProfileMenu />,
  }
  const hamburguer = {
    icon: {
      element: ICONS.HAM_MENU,
      onClick: () => toggleSidebar(),
    },
    id: ICONS.HAM_MENU,
  }
  const navigationDesktopItems = [
    topbarHelp,
    showNewAlertCenter ? NotificationsSystem : notification,
    topbarProfile,
  ]
  const navigationMobileItems = [
    showNewAlertCenter ? NotificationsSystem : notification,
    hamburguer,
  ]

  const renderLogo = () => {
    const isMladinska = isMladinskaPublisher(publishers)
    if (isMladinska) {
      return <MladinskaLogo />
    }
    if (!isLarge)
      return <Icon height={35} icon={'edubookLandscapeGradient'} width={110} />
    return null
  }

  return (
    <Sc.Container>
      <TopNavigation
        device={isLarge ? 'desktop' : 'tablet'}
        LeftContent={renderLogo()}
        RightContent={
          <NavigationItems
            items={
              isExtraSmall ? navigationMobileItems : navigationDesktopItems
            }
          />
        }
      />

      {isExtraSmall && (
        <Navigation
          isOpen={isSidebarOpen}
          onClose={handleCloseSidebar}
          type={NAVIGATION_TYPES.MENU}
        />
      )}
    </Sc.Container>
  )
}
Header.defaultProps = {
  children: null,
  className: null,
}

Header.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
}
export default Header
